import { Box, Button, MenuItem, Select, Typography } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import SearchFiedComponent from "../../Component/SearchComponent";
import debounce from "lodash.debounce";
import view from "../../Assets/View.png";
import demoImg from "../../Assets/demo.png";
import DataListingComponent from "../../Component/DataListingComponent";
import { useNavigate } from "react-router-dom";
import PathList from "../../Common/PathList";
import { API_GET, API_POST } from "../../API/config";
import { API_endspoints } from "../../API/API_endspoints";
import moment from "moment";
import { toast } from "react-toastify";
import ConfirmDeleteModal from "../../Component/Modal/ConfirmModal";
const PAGE_SIZE_OPTIONS = [15];
const OwnerManagement = () => {
  const [searchTerm, setSearchterm] = useState("");
  const [isActionLoading, setIsActionLoading] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState("");
  const [extendDate, setExtendDate] = useState({});
  const [data, setData] = useState([]);
  const [IsLoading, setIsLoading] = useState(true);
  const [totalData, setTotalData] = useState();
  const [page, setPage] = useState(0);
  const [selectedStatus, setSelectedStatus] = useState("");
  const navigate = useNavigate();
  const [rowsPerPage, setRowsPerPage] = useState(PAGE_SIZE_OPTIONS[0]);

  const handlePageChange = (e, newPage) => {
    setPage(newPage);
  };

  const handleStatusChange = (event) => {
    const status = event.target.value;
    setSelectedStatus(status);
  };

  const handleExtendTrailPackByUserId = async (id) => {
    try
    {
      setIsActionLoading(true);
      const res = await API_POST(API_endspoints.extendTrailPackByUserId, {
        user_id: id,
      });
      if (res?.s)
      {
        toast.success(res?.m);
        getPartnersData(
          selectedStatus,
          statusRef.current,
          searchTerm,
          searchRef.current,
          page,
          rowsPerPage
        );
      } else
      {
        toast.error(res?.m);
      }
      setIsActionLoading(false);
      setOpenConfirmModal("");
    } catch (error)
    {
      console.log(error);
      setIsActionLoading(false);
      setOpenConfirmModal("");
    }
  };

  const handleRowsPerPageChange = (e) => {
    setRowsPerPage(parseInt(e.target.value, 10));
    setPage(0);
  };

  const handleSearch = (event) => {
    setSearchterm(event.target.value);
  };

  const debouncedFetchData = debounce(() => {
    getPartnersData(
      selectedStatus,
      statusRef.current,
      searchTerm,
      searchRef.current,
      page,
      rowsPerPage
    );
    searchRef.current = searchTerm;
  }, 400);

  function formatStatus(status) {
    return status
      .toLowerCase()
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ')
  }


  const column = [
    {
      headerClassName: "super-app-theme--header",
      field: "rowid",
      headerName: "#",
      width: 80,
      headerAlign: "center",
      renderCell: (params) => params.row.rowid + page * rowsPerPage,
    },
    {
      headerClassName: "super-app-theme--header",
      field: "profile",
      headerName: "Profile",
      width: 100,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              className="ImgHover"
              src={
                cell?.row.image[0]
                  ? API_endspoints.baseURL + cell?.row.image[0]?.image
                  : demoImg
              }
              alt="icon"
              height={40}
              width={40}
              style={{ borderRadius: "8px" }}
            />
          </Box>
        </Box>
      ),
    },

    {
      headerClassName: "super-app-theme--header",
      field: "company_name",
      headerName: "Company Name",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
    },
    {
      headerClassName: "super-app-theme--header",
      field: "caterer_type",
      headerName: "Caterer Type",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => (
        <span>
          {cell.row.caterer_type === 1
            ? "Bussiness Caterer"
            : cell.row.caterer_type === 2
              ? "Food Trucks"
              : cell.row.caterer_type === 3
                ? "Barista/Bartender"
                : "Other"}
        </span>
      ),
    },
    {
      headerClassName: "super-app-theme--header",
      field: "avg_rating",
      headerName: "Rating",
      flex: 1,
      minWidth: 150,
      headerAlign: "center",
      renderCell: (cell) => cell?.row?.avg_rating ?? 0,
    },
    {
      headerClassName: "super-app-theme--header",
      field: "created_at",
      headerName: "Registered At",
      width: 180,
      headerAlign: "center",
      renderCell: (cell) =>
        cell?.row?.subscription?.start_time ? (
          <span>{`${moment
            .utc(cell?.row?.subscription?.start_time)
            .local()
            .format("lll")}`}</span>
        ) : (
          "-"
        ),
    },
    {
      headerClassName: "super-app-theme--header",
      field: "subscription",
      headerName: "Status",
      width: 150,
      headerAlign: "center",
      renderCell: (cell) =>
        cell?.row?.subscription?.status ? (
          <span>
            {formatStatus(cell.row.subscription.status)}
          </span>
        ) : (
          "Pending"
        ),
    },

    {
      headerClassName: "super-app-theme--header",
      field: "membership",
      headerName: "Membership",
      width: 150,
      headerAlign: "center",
      renderCell: (cell) => {
        let type = cell?.row?.subscription?.name;
        return type ?? "-";
      },
    },
    {
      headerClassName: "super-app-theme--header",
      field: "end_time",
      headerName: "Expired at",
      width: 180,
      headerAlign: "center",
      renderCell: (cell) =>
        cell?.row?.subscription?.end_time ? (
          <span>{`${moment
            .utc(cell?.row?.subscription?.end_time)
            .local()
            .format("lll")}`}</span>
        ) : (
          "-"
        ),
    },

    {
      headerClassName: "super-app-theme--header",
      field: "action",
      headerName: "Action",
      width: 120,
      headerAlign: "center",
      renderCell: (cell) => {
        const { status, type, start_time, end_time } =
          cell?.row?.subscription || {};
        const userId = cell?.row?.user_id;
        let x = { start_time, end_time };

        const isTrailPackExpired = status === "EXPIRED";
        const isTrailPack = type === 0;
        if (isTrailPack && isTrailPackExpired)
        {
          return (
            <Button
              type="submit"
              onClick={() => {
                setOpenConfirmModal(userId);
                setExtendDate(x);
              }}
              variant="contained"
              disabled={isActionLoading}
              sx={{
                width: "100px",
                textTransform: "none",
                borderRadius: "8px",
                backgroundColor: "#164FA1",
                "&:hover": {
                  backgroundColor: "#164FA1",
                },
                "&:disabled": {
                  background: "gray", // Style for the disabled button
                },
              }}
            >
              Extend
            </Button>
          );
        } else
        {
          return "-";
        }
      },
    },

    {
      headerClassName: "super-app-theme--header",
      field: "view",
      headerName: "View",
      width: 80,
      headerAlign: "center",
      renderCell: (cell) => (
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            width: "100%",
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: 3,
            }}
          >
            <img
              className="ImgHover"
              src={view}
              alt="View"
              height={24}
              width={24}
              onClick={() =>
                navigate(`${PathList._PartnerDetails}/${cell?.row?.company_id}`)
              }
            />
          </Box>
        </Box>
      ),
    },
  ];

  const STATUS_OPTIONS = [
    { value: "", label: "All" },
    { value: 1, label: "Bussiness Caterer" },
    { value: 2, label: "Food Trucks" },
    { value: 3, label: "Barista/Bartender" },
    { value: 4, label: "Other" },
  ];

  const getPartnersData = async (
    selectedStatus,
    prevStatus,
    search = "",
    searchRef = "",
    page = 0,
    pageSize = PAGE_SIZE_OPTIONS[0]
  ) => {
    setIsLoading(true);
    try
    {
      let newPage = page * pageSize;
      if (search !== searchRef || selectedStatus !== prevStatus)
      {
        newPage = 0;
        setPage(0);
      }
      let queryParams = new URLSearchParams({
        count: newPage,
      });

      if (search.length > 0)
      {
        queryParams.append("search", search);
      }
      if (selectedStatus)
      {
        queryParams.append("caterer_type", selectedStatus);
      }

      queryParams.append("is_admin", 1);

      const api = `${API_endspoints.getallpartners
        }?${queryParams.toString()}&offset=${pageSize}`;
      let res = await API_GET(api);
      const Rowdata = res?.r?.map((data, i) => ({
        rowid: i + 1,
        ...data,
      }));

      if (res?.r?.length > 0)
      {
        setData(Rowdata);
        setTotalData(res?.c ?? 0);
      } else
      {
        setData([]);
        setTotalData(0);
      }
    } catch (error)
    {
      console.error(error);
    } finally
    {
      setIsLoading(false);
    }
  };
  let searchRef = useRef(searchTerm);
  const statusRef = useRef(selectedStatus);

  useEffect(() => {
    getPartnersData(
      selectedStatus,
      statusRef.current,
      searchTerm,
      searchRef.current,
      page,
      rowsPerPage
    );
    searchRef.current = searchTerm;
    statusRef.current = selectedStatus;
  }, [page, rowsPerPage]);

  useEffect(() => {
    debouncedFetchData();
    return () => {
      debouncedFetchData.cancel();
    };
  }, [searchTerm, page, rowsPerPage, selectedStatus]);

  return (
    <Box sx={{ height: "calc(100vh - 32px)" }}>
      <Box
        sx={{
          height: "110px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          px: 2,
          width: "100%",
          background: "#ffffff",
          borderBottom: "1px solid #CED7E4",
        }}
      >
        {/* <Box> */}
        <Typography
          sx={{
            fontSize: "26px",
            fontWeight: 500,
          }}
        >
          {/* Food Truck Owner / Caterers Owner */}
          Partners
        </Typography>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: 1, // Adds spacing between label and dropdown
          }}
        >
          <SearchFiedComponent
            onChange={handleSearch}
            placeholder={"Search"}
            value={searchTerm}
          />
          <Select
            value={selectedStatus}
            onChange={handleStatusChange}
            displayEmpty
            size="small"
            sx={{
              minWidth: 150,
              padding: "4px 12px",
              fontSize: "14px",
              borderRadius: "8px",
              border: "1px solid #CED7E4",
              backgroundColor: "#F9F9F9",
              "&:hover": {
                backgroundColor: "#F0F0F0",
              },
            }}
          >
            {STATUS_OPTIONS.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </Box>
      </Box>

      <Box
        sx={{
          background: "#F4F4F4",
          height: "calc(100% - 115px)",
          width: "100%",

          p: 2,
        }}
      // className='flexCenter'
      >
        <DataListingComponent
          data={data ?? []}
          PAGE_SIZE_OPTIONS={PAGE_SIZE_OPTIONS}
          loading={IsLoading}
          totalData={totalData}
          page={page}
          Footer={true}
          columns={column}
          rowsPerPage={rowsPerPage}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
        />
        <ConfirmDeleteModal
          open={openConfirmModal}
          handleClose={() => {
            setOpenConfirmModal("");
          }}
          handleConfirm={() => handleExtendTrailPackByUserId(openConfirmModal)}
          title="Are you sure you want to extend the trial period?"
          subTitle={extendDate}
          confirmText="Extend"
        />
      </Box>
    </Box>
  );
};

export default OwnerManagement;
